import {generateAvatarURL, IRegistration, IUser} from "data/entities/IUser";
import {action, computed, observable} from "mobx";

export class User implements IUser {
  _id: string;
  @observable _location: string;
  @observable agreedToTerms: Date|null;
  @observable avatar: string;
  @observable bio: string;
  @observable dateCreated: Date;
  @observable email: string;
  @observable employeeOrSpouse: string;
  @observable extra: string;
  @observable firstName: string;
  @observable fitbitEnabled = false;
  @observable fitbitLastRefreshDate: Date|null;
  @observable goals: any[];
  @observable isAdmin: boolean;
  @observable isBoothHost: boolean;
  @observable isClientContact: boolean;
  @observable isDietitian: boolean;
  @observable isHealthFairHost: boolean;
  @observable isMainstagePresenter: boolean;
  @observable isTester: boolean;
  @observable isVendorBoothHost: boolean;
  @observable lastName: string;
  @observable loginCount: number;
  @observable nameOrNickname: string;
  @observable nickname: string;
  @observable registrations: IRegistration[];
  @observable vendorBooths?:string[];
  @observable clientContactAccessAckDate: Date;

  @action initFromJSON = (json:IUser) => {
    this._id = json._id;
    this.agreedToTerms = json.agreedToTerms;
    this.avatar = json.avatar;
    this.bio = json.bio;
    this.dateCreated = json.dateCreated;
    this.email = json.email;
    this.employeeOrSpouse = json.employeeOrSpouse;
    this.extra = json.extra;
    this.firstName = json.firstName;
    this.fitbitLastRefreshDate = json.fitbitLastRefreshDate;
    this.fitbitEnabled = json.fitbitEnabled;
    this.goals = json.goals;
    this.isAdmin = json.isAdmin;
    this.isBoothHost = json.isBoothHost;
    this.isClientContact = json.isClientContact;
    this.isDietitian = json.isDietitian;
    this.isHealthFairHost = json.isHealthFairHost;
    this.isMainstagePresenter = json.isMainstagePresenter;
    this.isTester = json.isTester;
    this.isVendorBoothHost = json.isVendorBoothHost;
    this.lastName = json.lastName;
    this.loginCount = json.loginCount;
    this.nameOrNickname = json.nameOrNickname;
    this.nickname = json.nickname;
    this.registrations = json.registrations;
    this._location = json._location;
    this.vendorBooths = json.vendorBooths;
    this.clientContactAccessAckDate = json.clientContactAccessAckDate;
  }

  @computed get avatarURL() {
    return generateAvatarURL(this.avatar);
  }

  zoomRegistrationForBundleId = (bundleId) => {
    if(this.registrations) {
      for(let r=0;r<this.registrations.length;r++) {
        const reg:any = this.registrations[r];
        if(reg.bundleRegistrations) {
          for(let br=0;br<reg.bundleRegistrations.length;br++) {
            const bundleReg:any = reg.bundleRegistrations[br];
            if(bundleReg.bundleId===bundleId) {
              return bundleReg;
            }
          }
        }
      }
    }
    return null;
  }

  constructor(json:IUser|null) {
    if(json) {
      this.initFromJSON(json);
    }
  }

}




